import { render, staticRenderFns } from "./EditSharedCredentialPage.vue?vue&type=template&id=6ea235a1&"
import script from "./EditSharedCredentialPage.vue?vue&type=script&lang=js&"
export * from "./EditSharedCredentialPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports